module.exports = __webpack_public_path__ + "img/theme.92a183b9.jpg";